import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaCheck } from 'react-icons/fa';
import DemoPopover from './DemoPopover';

const FEATURES = [
  'Student profile management',
  'Campus drive co-ordination',
  'Recruiter onboarding',
  'Resume collection & eligibility filters',
  'Interview scheduling',
  'Placement analytics dashboard',
  'Training session management',
];

export default function PlacementERPBand({ onStartSearching }) {
  const [showDemo, setShowDemo] = useState(false);

  return (
    <>
      <section id="colleges" className="py-14 md:py-24 px-4 sm:px-6 bg-secondary-50 border-t border-secondary-100">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-8 md:gap-16 items-center">

          {/* Copy */}
          <motion.div
            initial={{ opacity: 0, x: -24 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <span className="text-xs font-black tracking-widest uppercase text-brand-purple mb-3 block">
              For Colleges & Institutions
            </span>
            <h2 className="font-display font-black text-3xl md:text-4xl lg:text-5xl text-ink-900 leading-tight mb-6">
              Replace spreadsheets with a placement engine your TPO will actually like.
            </h2>
            <p className="text-ink-500 text-lg leading-relaxed mb-8">
              Our Placement ERP digitises every step — from student registration to offer letter
              tracking — so your team stops copy-pasting and starts closing placements.
            </p>
            <ul className="space-y-3 mb-10">
              {FEATURES.map(f => (
                <li key={f} className="flex items-center gap-3 text-sm font-semibold text-ink-700">
                  <span className="w-5 h-5 rounded-full bg-brand-purple flex items-center justify-center shrink-0">
                    <FaCheck className="text-white text-[10px]" />
                  </span>
                  {f}
                </li>
              ))}
            </ul>
            <button
              onClick={() => setShowDemo(true)}
              className="px-8 py-4 rounded-2xl font-black text-sm tracking-wide text-white
                         bg-brand-purple hover:brightness-110 active:scale-95
                         transition-all shadow-purple"
            >
              Book a demo for your college →
            </button>
          </motion.div>

          {/* Placement ERP screenshot */}
          <motion.div
            initial={{ opacity: 0, x: 24 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="rounded-3xl overflow-hidden border border-secondary-200 shadow-glass-xl"
          >
            <img
              src={require('../../assets/ss/placement_ss.png')}
              alt="Placement ERP dashboard showing annual placement report"
              className="w-full h-full object-cover object-top"
            />
          </motion.div>

        </div>
      </section>

      <DemoPopover open={showDemo} onClose={() => setShowDemo(false)} />
    </>
  );
}
